import Skeleton from "@mui/material/Skeleton";
import React from "react";

export default function ConvSkel() {
  return <Skeleton height="4em" sx={{ transform: "scale(1, 0.8)" }} />;
}
